<app-page-header
  title="Home"
  [active_item]="'common.lotteryModalities' | translate"
  titleLink="/product"
></app-page-header>
<div class="loading-wallet" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ "common.lotteryModalities" | translate }}</h5>
<form [formGroup]="product">
  <div class="row">
    <div class="col-12">
      <div class="card rounded-10 shadow" *ngIf="!isInsert">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <div class="card-title mb-0">{{ "common.modalities" | translate }}</div>
          <button
            type="button"
            class="our-button btn btn-pill btn-primary float-end"
            (click)="openInsert()"
          >
            <i class="fe fe-plus"></i>{{ "common.modalities" | translate }}
          </button>
        </div>
        <div class="card-body">
          <div class="scrollable-layout">
            <div class="table-responsive our-table">
              <table class="table table-striped text-nowrap mb-0">
                <thead class="border-top">
                  <tr>
                    <th scope="col" class="text-capitalize">
                      {{ "common.registrationId" | translate }}
                    </th>
                    <th scope="col" class="text-capitalize">
                      {{ "common.modality" | translate }}
                    </th>
                    <th scope="col" class="text-capitalize">
                      {{ "common.description" | translate }}
                    </th>
                    <th scope="col" class="text-capitalize">
                      {{ "common.observations" | translate }}
                    </th>
                    <th scope="col" class="text-capitalize">
                      {{ "common.update" | translate }}
                    </th>
                    <th
                      class="align-middle text-center text-capitalize"
                      scope="col"
                    >
                      {{ "common.status" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="border-bottom" *ngFor="let product of products">
                    <td>
                      <span>{{ product.id }}</span>
                    </td>
                    <td>
                      <span>{{ product.type }}</span>
                    </td>
                    <td>
                      <span>{{ product.name }}</span>
                    </td>
                    <td>
                      <span>{{ product.message }}</span>
                    </td>
                    <td>
                      <span>{{ product.updatedAt | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <label class="custom-switch">
                        <input
                          type="checkbox"
                          class="custom-switch-input"
                          [checked]="product.active"
                          (click)="
                            $event.preventDefault();
                            $event.stopPropagation();
                            showConfirmEnableDisable(
                              modalConfirmEnable,
                              product
                            )
                          "
                        />
                        <span class="custom-switch-indicator"></span>
                      </label>
                    </td>
                  </tr>
                  <tr *ngIf="isLoaded && (products?.length || 0) === 0">
                    <td colspan="9">{{ "common.noData" | translate }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-between p-2">
                <ngb-pagination
                  [collectionSize]="total"
                  [maxSize]="5"
                  [rotate]="true"
                  [(page)]="page"
                  [pageSize]="pageSize"
                  (pageChange)="pageChange()"
                >
                </ngb-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card rounded-10 shadow" *ngIf="isInsert">
        <div class="card-header">
          <div class="card-title mb-0">
            {{ "common.addModality" | translate }}
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtType" class="form-label"
                  >{{ "common.modalityType" | translate }}
                  <span class="text-danger">*</span></label
                >
                <input
                  [formControl]="product.controls.type"
                  class="form-control"
                  type="text"
                  id="txtType"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      product.controls.type.invalid && isSubmitted,
                  }"
                />
                <div class="invalid-feedback">
                  {{ "common.fieldRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtName" class="form-label"
                  >{{ "common.description" | translate }}
                  <span class="text-danger">*</span></label
                >
                <input
                  [formControl]="product.controls.name"
                  class="form-control"
                  type="text"
                  id="txtName"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      product.controls.name.invalid && isSubmitted,
                  }"
                />
                <div class="invalid-feedback">
                  {{ "common.fieldRequired" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtMessage" class="form-label"
                  >{{ "common.observations" | translate }}
                  <span class="text-danger">*</span></label
                >
                <input
                  [formControl]="product.controls.message"
                  class="form-control"
                  type="text"
                  id="txtMessage"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      product.controls.message.invalid && isSubmitted,
                  }"
                />
                <div class="invalid-feedback">
                  {{ "common.fieldRequired" | translate }}
                </div>
              </div>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-pill btn-primary float-start"
            (click)="return()"
          >
            <i class="fe fe-arrow-left"></i>{{ "common.back" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-pill btn-primary float-end"
            (click)="add()"
          >
            <i class="fe fe-plus"></i>{{ "common.add" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>

<ng-template #modalConfirmEnable let-modal>
  <div class="modal-content" style="padding: 0 !important">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ !selectedWallet?.active ? ("common.enableModality" | translate) : ("common.disableModality" | translate) }}
      </h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click'); loadProducts()"
      ></button>
    </div>

    <div class="modal-body">
      <p>
        Este processo irá
        {{ !selectedWallet?.active ? "habilitar" : "desabilitar" }}
        a modalidade selecionada.
      </p>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="modal.close('Close click'); loadProducts()"
      >
        Cancelar
      </button>

      <button
        class="btn btn-{{ !selectedWallet.active ? 'primary' : 'danger' }}"
        type="button"
        (click)="modal.close(); openTotpForToggle()"
      >
        {{ !selectedWallet.active ? "Habilitar" : "Desabilitar" }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>

  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>

    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />

      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{ "login.totp.pasteButton" | translate }}
      </button>
    </div>
  </div>

  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
